import { useMutation } from '@tanstack/react-query';

import { AxiosError } from 'axios';

import {
  PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody,
  TPrototypePartialDto,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useCreateGuestBatchScenarioPartialsMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { guestPartials } = useAvApi();

  return useMutation<
    TPrototypePartialDto[] | undefined,
    AxiosError,
    {
      partialsBatch: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody[];
      prototypeId: string;
    }
  >({
    retry: 0,
    mutationKey: ['create-batch-scenario-partial-mutation-guest'],
    mutationFn: async ({
      partialsBatch,
      prototypeId,
    }: {
      partialsBatch: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody[];
      prototypeId: string;
    }) => {
      if (!workspaceId) return;

      const pageData = new FormData();

      for (const partial of partialsBatch) {
        pageData.append('index', partial.index);
        pageData.append('image', partial.image);
        pageData.append('name', partial.name);
        pageData.append('type', partial.type);
        pageData.append('data', partial.data);
        pageData.append('fileName', partial.fileName);
      }

      // TODO fix any
      /* eslint-disable */
      const res =
        await guestPartials.postGuestPrototypesPartialsBatchByProjectIdAndPrototypeId(
          pageData as any,
          {
            projectId: workspaceId,
            prototypeId,
          },
          {} as any,
          {
            headers: {
              'Content-Type': 'multipart/form',
            },
            signal,
          }
        );
      /* eslint-disable */
      return res.data;
    },
  });
};
